import { designTokens } from './tokens';

export const componentOverrides = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        fontSize: designTokens.fontSize.base,
        lineHeight: 1.5,
      },
    },
  },

  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: designTokens.borderRadius.medium,
        fontWeight: designTokens.fontWeights.medium,
        textTransform: 'none',
        padding: `${designTokens.spacing.sm}px ${designTokens.spacing.md}px`,
        '&:hover': {
          transform: 'translateY(-1px)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        },
        transition: 'all 0.2s ease-in-out',
      },
      containedPrimary: {
        backgroundColor: (theme) => theme.palette.primary.main,
        color: (theme) => theme.palette.primary.contrastText,
        '&:hover': {
          backgroundColor: (theme) => theme.palette.primary.dark,
        },
      },
    },
  },

  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: designTokens.borderRadius.large,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
        '&:hover': {
          boxShadow: '0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)',
        },
        transition: 'box-shadow 0.3s ease-in-out',
      },
    },
  },

  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
      rounded: {
        borderRadius: designTokens.borderRadius.medium,
      },
    },
  },

  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: designTokens.borderRadius.medium,
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: (theme) => theme.palette.primary.light,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: (theme) => theme.palette.primary.main,
          },
        },
      },
    },
  },

  MuiTabs: {
    styleOverrides: {
      root: {
        '& .MuiTabs-indicator': {
          height: 3,
          borderRadius: designTokens.borderRadius.pill,
        },
      },
    },
  },

  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontWeight: designTokens.fontWeights.medium,
        fontSize: designTokens.fontSize.base,
        minHeight: 48,
        '&.Mui-selected': {
          color: (theme) => theme.palette.primary.main,
        },
      },
    },
  },

  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        fontSize: designTokens.fontSize.sm,
        borderRadius: designTokens.borderRadius.medium,
        padding: `${designTokens.spacing.sm}px ${designTokens.spacing.md}px`,
      },
    },
  },

  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: designTokens.borderRadius.pill,
        fontSize: designTokens.fontSize.sm,
        fontWeight: designTokens.fontWeights.medium,
      },
    },
  },

  MuiTableCell: {
    styleOverrides: {
      root: {
        paddingTop: designTokens.spacing.xs,
        paddingBottom: designTokens.spacing.xs,
      },
      head: {
        fontWeight: designTokens.fontWeights.semiBold,
        backgroundColor: (theme) => theme.palette.background.dark,
        color: (theme) => theme.palette.text.secondary,
      },
    },
  },

  MuiLinearProgress: {
    styleOverrides: {
      root: {
        borderRadius: designTokens.borderRadius.small,
        overflow: 'hidden',
      },
    },
  },

  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: 32,
      },
    },
  },

  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
      },
    },
  },

  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderRight: `1px solid ${designTokens.customColors.background.grey}`,
      },
    },
  },
};
